import React from 'react'
import './CheckoutProduct.css'
import { useStateValue } from '../StateProvider'

function CheckoutProduct(props) {

    const [{cart}, dispatch] = useStateValue()

    const removeFromCart = () => {
        dispatch({
            type:"REMOVE_FROM_CART",
            id:props.id
        })
    }
    return (
        <div className="checkoutProduct">
            <img className="checkoutProduct__image" src={props.image} alt ="" />
            <div className="checkoutProduct__info">
                <p className="checkoutProduct__name">{props.name}</p>
                <p className="checkoutProduct__price">
                    <small>₹</small>
                    <strong>{props.price}</strong>
                </p>
                <div className="checkoutProduct__rating">
                    {Array(props.rating)
                    .fill()
                    .map((i) => (
                        // eslint-disable-next-line jsx-a11y/accessible-emoji
                        <p> 🌟</p>
                    ))}
                </div>
                <button onClick={() => {removeFromCart()}}> Remove from Cart</button>
            </div>
           
        </div>
    )
}

export default CheckoutProduct
